import * as React from 'react';
import {View, StyleSheet} from 'react-native';
import AVText from 'src/components/elements/AVText';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
import AlertCircleExclamation from 'src/components/img/AlertCircleExclamation';
import Styles from 'src/components/Styles';

type DialogueHeaderlProps = {
  headerTitle: string;
};

const DialogueHeader = (props: DialogueHeaderlProps) => {
  return (
    <View
      style={styles.innerContent}
      accessible
      accessibilityLabel="Modal Header"
    >
      {<AlertCircleExclamation />}
      <AVText
        style={[
          styles.headerText,
          getSnackDescriber()?.snackDetailsBtnFontSTyle(),
        ]}
        accessible
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm0}
        aria-label={`${props.headerTitle}Text`}
        accessibilityLabel={props.headerTitle}
        testID="qa_Checkout.ModalTitle_txt"
        nativeID="qa_Checkout.ModalTitle_txt"
      >
        {props.headerTitle}
      </AVText>
    </View>
  );
};

const styles = StyleSheet.create({
  innerContent: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: Styles.Spacing.m3,
    marginTop: 45,
  },
  headerText: {
    color: Styles.black,
    fontSize: Styles.Fonts.sectionHeader + 2,
    fontWeight: '700',
    marginLeft: Styles.Spacing.m2,
    textAlign: 'center',
    marginTop: Styles.Spacing.m2,
  },
});
export default DialogueHeader;
